import React from "react";
import appleImg from "../../../images/apple.png";
import { sendEvent } from "../../../utils/event";

const AppleLogin = () => {
  const login = () => {
    sendEvent("Applee");
  }
  return (
    <>
      <div className="googleLoginButton" style={{ width: "100%" }}>
        <button
          onClick={() => {
            login()
            // sendEvent("applee"); // Trigger the event on successful login
          }}
          //   onClick={() => login()}
          className="mt-1 secondary-button text-black items-center !justify-center flex h-11 border border-gray-300"
        >
          {
            <img
              src={appleImg}
              className=" w-7 inline-block mx-1"
              alt="Google-logo"
            />
          }
          <span className="">Continue With Apple</span>
        </button>
      </div>
    </>
  );
};

export default AppleLogin;
